import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../redux/store';
import { Navigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

export const AuthGate: React.FC<Props> = ({ children }) => {
  const isAuthenticated = useSelector((s: RootState) => s.auth.isAuthenticated);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

export default AuthGate;

